import React, { useState, useEffect, useRef } from 'react';

function CameraSwitcher() {
  const [cameras, setCameras] = useState([]);
  const [currentCamera, setCurrentCamera] = useState(null);
  const videoRef = useRef(null);

  // Function to get the list of available cameras
  const getCameras = async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter(device => device.kind === 'videoinput');
      setCameras(videoDevices);
      if (videoDevices.length > 0) {
        setCurrentCamera(videoDevices[0].deviceId); // Set the first camera by default
      }
    } catch (err) {
      console.error("Error getting devices:", err);
    }
  };

  // Function to start the camera stream
  const startCamera = async (deviceId) => {
    if (videoRef.current) {
      try {
        // Stop the current stream (if any)
        const currentStream = videoRef.current.srcObject;
        if (currentStream) {
          const tracks = currentStream.getTracks();
          tracks.forEach(track => track.stop());
        }
  
        // Get the new media stream for the selected camera
        const newStream = await navigator.mediaDevices.getUserMedia({
          video: { deviceId: { exact: deviceId } }
        });
        videoRef.current.srcObject = newStream;
      } catch (err) {
        console.error("Error starting the camera:", err);
      }
    }
  };
  

  // Function to handle camera selection change
  const handleCameraChange = (event) => {
    const selectedCameraId = event.target.value;
    setCurrentCamera(selectedCameraId);
    startCamera(selectedCameraId);
  };

  // Effect to get available cameras when the component mounts
  useEffect(() => {
    getCameras();
  }, []);

  // Start the first camera when component mounts
  useEffect(() => {
    if (currentCamera) {
      startCamera(currentCamera);
    }
  }, [currentCamera]);

  return (
    <div>
      <h1>Select Camera</h1>
      <select onChange={handleCameraChange} value={currentCamera}>
        {cameras.map((camera) => (
          <option key={camera.deviceId} value={camera.deviceId}>
            {camera.label || `Camera ${camera.deviceId}`}
          </option>
        ))}
      </select>

      <video ref={videoRef} autoPlay playsInline width="640" height="480" />
    </div>
  );
}

export default CameraSwitcher;
